import React from 'react';
import './App.css';
import Routers from './RoutersFile/Routers';
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <Routers />
      <ToastContainer autoClose={5000} position="top-right" />
    </>
  );
}

export default App;
